import i18n from 'i18next';
import { Helmet } from '@dr.pogodin/react-helmet';
import { useLocation } from 'react-router';
import { FC } from 'react';
import { SITE_LANGUAGES, setPathLocale } from '../../common/localeShared';

export const LocationMetaTags: FC<any> = (props: any) => {
  const location = useLocation();

  return (
    <Helmet>
      {SITE_LANGUAGES.map(({ sitePathRoot, localeCode }) => (
        <link
          key={sitePathRoot}
          rel="alternate"
          hrefLang={localeCode}
          href={`${RIO_SITE.external_url}${setPathLocale(location.pathname, sitePathRoot)}`}
        />
      ))}

      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${RIO_SITE.external_url}${setPathLocale(location.pathname, 'en')}`}
      />

      <link rel="canonical" href={`${RIO_SITE.external_url}${setPathLocale(location.pathname, i18n.language)}`} />
    </Helmet>
  );
};
